import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { toast } from 'ngx-sonner';

@Injectable({
    providedIn: 'root',
})
export class VersionUpdateService {
    constructor(private swUpdate: SwUpdate) {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.versionUpdates
                .pipe(
                    filter(
                        (evt): evt is VersionReadyEvent =>
                            evt.type === 'VERSION_READY',
                    ),
                )
                .subscribe(() => {
                    this.showUpdateToaster();
                });
        }
    }

    private showUpdateToaster(): void {
        toast('New version available!', {
            description:
                'A new version of the application is ready. Please reload to update.',
            action: {
                label: 'Update Now',
                onClick: () => window.location.reload(),
            },
            duration: Infinity,
            important: true,
        });
    }
}
